import axios from 'axios';

export const wmcApi = axios.create({
  baseURL: 'https://wmcapi.herokuapp.com/api/',
});
